
import type { CompanyVO, RecruitmentInfo, QichachaVO } from '../../services/company';
import { requestGetCompanyInfoById, getJobDetail, requestGetQichachaByCompanyId2 } from '../../services/company';
import { useState, useEffect } from 'react';
import { Layout, Row, Col, Card, Image, Divider, Space, Button, Avatar, Tag, Descriptions, Tooltip, Menu, Badge, Breadcrumb, Popover, Typography } from 'antd';
// import { createFromIconfontCN } from '@ant-design/icons';

import {
  UserOutlined, PaperClipOutlined, EditOutlined,
  ClockCircleFilled,
  RestFilled,
  SoundOutlined,
  CaretRightOutlined,
  HomeOutlined,
  HourglassFilled,
  ShareAltOutlined,
  WarningOutlined,
  CopyOutlined,
  WechatOutlined,
  AppstoreAddOutlined,
  GlobalOutlined,
  TagsFilled

} from '@ant-design/icons';
import { useParams } from 'react-router-dom';
import { IMAGE_URL, IMAGE_ERRER } from '../../config/index'
// import styles from '../company/style.less'
// const { TabPane } = Tabs;
const { Meta } = Card;
const { Paragraph } = Typography;
// 调用图标 ciconfont.cn
// const IconFont = createFromIconfontCN({
//   scriptUrl: '//at.alicdn.com/t/c/font_3869023_s6kx5b2eglj.js',
// });
import MapComponent from '../../MapContainer';
const { Header, Content, Footer } = Layout;
// import { history } from 'umi';
const JobDetailView = () => {

  const params = useParams();
  console.log(params,'11111222')
  // if (location.host.indexOf('localhost:3000')>=0) {
    let stringUrl = 'https://student.hjiuye.com/job/'
 
    if (params && params.id != undefined && params.collegeId) {
      stringUrl = stringUrl+ params.id +'/'+params.collegeId
    }else if (params && params.id != undefined) {
      stringUrl = stringUrl+params.id
    }
    // window.stop()
    // window.open(stringUrl)
    // history.push(stringUrl)
    window.location.assign(stringUrl)
  // }
  const [jobId, setJobId] = useState<string>('0');
  const [collegeId, setCollegeId] = useState<string>('2664');
  const [recruitmentInfo, setRecruitmentInfo] = useState<RecruitmentInfo>();
  const [companyInfoDetail, setCompanyInfoDetail] = useState<CompanyVO>();
  const [qichachaCompany, setQichachaCompany] = useState<QichachaVO>();
  const getQichachaCompanyInfo = async () => {
    const res = await requestGetQichachaByCompanyId2({ companyId: companyInfoDetail?.id, companyName: companyInfoDetail?.fullName });
    if (res.code == 1) {
      setQichachaCompany(res.data)
    }
  }
  const getCompanyInfo = async () => {
    const res = await requestGetCompanyInfoById({ id: recruitmentInfo?.companyInfo?.id });
    if (res.code == 1) {
      setCompanyInfoDetail(res.data)
    }
    // getQichachaCompanyInfo()
  }
  const getRecruitmentInfo = async () => {
    const res = await getJobDetail({ id: parseInt(jobId) });
    if (res.code == 1) {
      setRecruitmentInfo(res.data)
    }

  }
  useEffect(() => {
    if (jobId && jobId != '0') {
      getRecruitmentInfo()
    }
  }, [jobId]);
  // useEffect(() => {
  //   console.log(location.host,'11111')
  //   if (location.host.indexOf('localhost:3000')>=0) {
  //     let stringUrl = 'https://student.hjiuye.com/job/'
   
  //     if (params && params.id != undefined && jobId != params.id && params.collegeId) {
  //       stringUrl = stringUrl+ params.id +'/'+params.collegeId
  //     }else if (params && params.id != undefined) {
  //       stringUrl = stringUrl+params.id
  //     }
  //     // window.stop()
  //     window.open(stringUrl)
  //     return;
  //   }
  //   console.log(location.host,'11111')
  //   if (params && params.id != undefined && jobId != params.id) {
  //     setJobId(params.id)
  //   }
  //   if (params && params.id != undefined && jobId != params.id && params.collegeId) {
  //     setCollegeId(params.collegeId)
  //   }
  // }, [params]);
  useEffect(() => {

    if (recruitmentInfo?.companyInfo && recruitmentInfo?.companyInfo?.id && (companyInfoDetail == undefined || companyInfoDetail.id != recruitmentInfo?.companyInfo?.id)) {
      getCompanyInfo()
    }
  }, [recruitmentInfo]);
  useEffect(() => {
    if (companyInfoDetail && companyInfoDetail?.id != 0 && companyInfoDetail?.fullName != undefined && (qichachaCompany == undefined || qichachaCompany?.companyInfoId != companyInfoDetail.id)) {
      getQichachaCompanyInfo()
    }
  }, [companyInfoDetail]);
  // const companyImgs = () => {
  //   const html = [];
  //   if (companyInfoDetail && companyInfoDetail?.imgList && companyInfoDetail?.imgList.length > 0) {
  //     for (const item of companyInfoDetail.imgList) {
  //       if (item != undefined && item.id != undefined) {
  //         html.push(<div> <Image
  //           height={200}
  //           style={{ marginTop: 8 }}
  //           src={showUrl(item.imagePath)}
  //           fallback={IMAGE_ERRER}
  //         /></div>);
  //       }
  //     }
  //   }
  //   return html;
  // }

  //图片 或 文件对象链接
  const showUrl = (urlString?: string) => {
    if (urlString == undefined) {
      return IMAGE_ERRER;
    }
    return urlString && (urlString.indexOf("http") == 0) ? urlString : IMAGE_URL + urlString;
  }

  // 薪资数字样式
  const jobsalaryStyle = {
    color: '#f26d49'
  };
  const getJobPaySalary = (item: RecruitmentInfo) => {
    const jobType = item?.jobTypeList && item?.jobTypeList.length >= 1 ? item?.jobTypeList[0] : undefined;
    if (jobType && jobType?.id == 1) {
      return (<div style={jobsalaryStyle}>{item.totalIncomeStart?.content}-{item.totalIncomeEnd?.content}/月</div>)
    } else if (jobType && jobType?.id == 2) {
      return (<div style={jobsalaryStyle}>{item.totalIncomeStart?.content}-{item.totalIncomeEnd?.content}/月</div>)
    } else if (jobType && jobType?.id == 3) {
      if (item.payType?.id == 1) {
        return (<div style={jobsalaryStyle}>{item.paySalary}/小时</div>)
      } else if (item.payType?.id == 2) {
        return (<div style={jobsalaryStyle}>{item.paySalary}/天</div>)
      } else if (item.payType?.id == 3) {
        return (<div style={jobsalaryStyle}>{item.paySalary}/月</div>)
      }
    }
  }
  const getPaySettlementType = (item: RecruitmentInfo) => {
    const jobType = item?.jobTypeList && item?.jobTypeList.length >= 1 ? item?.jobTypeList[0] : undefined;
    if (jobType && jobType?.id == 3) {
      if (item.paySettlementType?.id == 1) {
        return (<div>   <Tag color="green" >日结</Tag></div>)
      } else if (item.paySettlementType?.id == 2) {
        return (<div >  <Tag color="green" >周结</Tag></div>)
      } else if (item.paySettlementType?.id == 3) {
        return (<div >  <Tag color="green" >月结</Tag></div>)
      }
    }
  }
  //图片 或 文件对象链接
  const showPostionImage = (item?: RecruitmentInfo) => {
    if (item == undefined) {
      return IMAGE_ERRER;
    }
    return 'https://api2.hjiuye.com/wechat/miniapp/wxacodeReq?scene=' + collegeId + ',' + item.id + '&page=pages/tabs/position/positioninfo/positioninfo';
  }

  // 立即沟通气泡框内容
  const chatContent = (
    <div style={{ width: 300, display: 'flex' }}>
      <div style={{ padding: 8, margin: 'auto' }}>
        Hi~ 对我职位感兴趣？快来微信小程序和我聊聊吧，还能在线视频面试，方便又安心～
      </div>
      <div style={{ float: 'right' }}>
        <Image
          width={120}
          height={120}
          src={showPostionImage(recruitmentInfo)}
          fallback={IMAGE_ERRER}
        />
      </div>
    </div>
  );
  const applyContent = (
    <div style={{ width: 300, display: 'flex' }}>
      <div style={{ padding: 8, margin: 'auto' }}>
        扫码进入小程序投递简历
      </div>
      <div style={{ float: 'right' }}>
        <Image
          width={120}
          height={120}
          src={showPostionImage(recruitmentInfo)}
          fallback={IMAGE_ERRER}
        />
      </div>
    </div>
  );
  //大学生防诈骗关注二维码提示信息
  const alertContent =
    (
      <div style={{ width: 300, display: 'flex' }}>
        <div style={{ padding: 8, margin: 'auto' }}>
          马上关注慧就业官方大学生就业公众号，更多安全就业常识即时查看
        </div>
        <div style={{ float: 'right' }}>
          <Image
            width={120}
            height={120}
            src='/qrcode_for_gh_0cc05d13d5eb_258.jpg'
            fallback={IMAGE_ERRER}
          />
        </div>
      </div>
    );
  const showPostionWorkPlaceList = () => {
    let showStr = ''
    if (recruitmentInfo?.workPlaceList && recruitmentInfo?.workPlaceList.length >= 1) {
      recruitmentInfo?.workPlaceList.map((item) => (
        showStr = showStr + item.showText + ';'
      ))
    }
    return showStr
    //    const html: React.ReactNode = [];
    // if (recruitmentInfo && recruitmentInfo?.workPlaceList && recruitmentInfo?.workPlaceList.length > 0) {
    //   recruitmentInfo?.workPlaceList.map((item, index) => (
    //     html.push(<div><span key={index}>{item.showText}</span></div>)
    //   ))
    // }
    // return html;
  }

  return (
    <Layout className='layout' style={{ background: 'linear-gradient(#e4f1f1 0px, #f2f4f7 80%, #f6f6f8 100%)', minHeight: '100vh' }} >

      {/* 头部header */}
      <Header>
        <div style={{ float: 'left', width: 50 }}>
          {/* <img src='https://bkimg.cdn.bcebos.com/pic/5243fbf2b2119313b07e3e8a3d721bd7912397dd27fc?x-bce-process=image/resize,m_lfit,w_536,limit_1' style={{ width: '100%' }} /> */}
        </div>
        <Menu
          theme="dark"
          mode="horizontal"
          defaultSelectedKeys={['2']}
        />
      </Header>
      <div style={{ padding: '18px 0 20px', background: 'linear-gradient(90deg,#3b526a 0,#386d88 100%)' }}>
        <Row>
          <Col span={14} style={{ margin: '0 auto' }}>
            <Row >
              <Col span={20}>
                <div>
                  <Row>
                    <Col span={18}>
                      <Row>
                        <Space align='center' size={30}>
                          <span style={{ color: '#ffffff', fontSize: 28, fontWeight: 600, maxWidth: 600 }}>{recruitmentInfo?.positionName} </span>
                          <span style={{ minWidth: 120, fontWeight: 500, fontSize: 34 }}>{recruitmentInfo && getJobPaySalary(recruitmentInfo)}</span>
                        </Space>
                      </Row>
                    </Col>
                  </Row>
                  <Row style={{ marginTop: 16 }}>
                    <Col span={18} style={{ color: '#ffffff' }} >

                      <Space size={0} split={<Divider type="vertical" style={{ backgroundColor: '#ffffff' }} />} wrap>
                        {recruitmentInfo && recruitmentInfo?.jobTypeList && recruitmentInfo?.jobTypeList.length >= 1 && recruitmentInfo?.jobTypeList.map((item, index) => (
                          <span key={index}>{item.content}</span>
                        ))}

                        {recruitmentInfo?.degreeStart && <span >{recruitmentInfo?.degreeStart?.name}</span>}
                        {recruitmentInfo?.recruitmentGroup == undefined && recruitmentInfo?.postNum != undefined && <span >{recruitmentInfo?.postNum} 人</span>}
                        {recruitmentInfo?.recruitmentGroup != undefined && recruitmentInfo?.recruitmentGroup.recruitmentNum != undefined && recruitmentInfo?.postNum == undefined && <span >{recruitmentInfo?.recruitmentGroup.recruitmentNum}人</span>}
                        {recruitmentInfo && getPaySettlementType(recruitmentInfo)}
                        <span>{recruitmentInfo?.isSolveHukou == 1 ? '解决户口' : '不解决户口'}</span>
                        {recruitmentInfo && recruitmentInfo?.workPlaceList && recruitmentInfo?.workPlaceList.length == 1 && recruitmentInfo?.workPlaceList.map((item, index) => (
                          <span key={index}>{item.showText}</span>
                        ))}
                        {recruitmentInfo && recruitmentInfo?.workPlaceList && recruitmentInfo?.workPlaceList.length >= 2 && <div><span>{recruitmentInfo?.workPlaceList[0].showText}</span><Popover
                          // placement="topLeft"
                          title='工作地点'
                          content={showPostionWorkPlaceList()}
                        // description="Are you sure to delete this task?"
                        // okText="Yes"
                        // cancelText="No"
                        >
                          <span>  更多工作地点</span>
                        </Popover></div>}

                      </Space>
                    </Col>
                  </Row>
                  <Row>
                    <Col span={20} style={{ marginTop: 35 }}>
                      <Space>
                        <Popover placement='bottom' content={chatContent}>
                          <Button type="primary" size='large' shape='round' ghost style={{ color: '#fff' }}>
                            立即沟通
                          </Button>
                        </Popover>
                        <Popover placement='bottom' content={applyContent}>
                          <Button type="primary" size='large' shape='round' ghost >
                            投递简历
                          </Button>
                        </Popover>
                        {/* <Button type="primary" size='large' shape='round'  >
                          投递简历
                        </Button> */}

                      </Space>
                    </Col>
                  </Row>
                </div>
              </Col>
              <Col span={4} style={{ marginTop: 20 }}>

                {/* <Space direction='vertical' size={0} >
                  <Button type="link" icon={<EditOutlined />} >完善在线简历</Button>
                  <Button type="link" icon={<PaperClipOutlined />} >上传简历附件 </Button>
                </Space> */}
                <div style={{ marginTop: 40, padding: '0 15px' }}>
                  <Space>
                    {/* <Tooltip title="校招违规举报">
                      <Button type='primary' icon={<WarningOutlined />} size='small' ghost />
                    </Tooltip>
                    <Tooltip title="分享">
                      <Button type='primary' icon={<ShareAltOutlined />} size='small' ghost />
                    </Tooltip> */}
                    {/* <Tooltip title="小程序访问">
                      <Button type='primary' icon={<WechatOutlined />} size='small' ghost />
                    </Tooltip> */}
                    <Button type='primary' size='small' ghost >
                      <Paragraph
                        copyable={{
                          text: location.href,
                          icon: [<CopyOutlined key="copy-icon" />],
                          tooltips: ['复制链接']
                        }}
                      >
                      </Paragraph>
                    </Button>
                    {/* <Tooltip title="复制链接">
                      <Button type='primary' icon={<CopyOutlined />} size='small' ghost onClick={() => {
                        console.log(location.href)
                        copyUrl()
                      }} />
<Paragraph
                      copyable={{
                        text:location.href,
                        icon:[<CopyOutlined />] 
                      }}
                    >
                      复制链接
                    </Paragraph>
                    </Tooltip> */}

                  </Space>
                </div>
              </Col>
            </Row>
          </Col>

        </Row>
      </div>
      <Content style={{ width: 1200, maxWidth: 1200, margin: '0 auto' }}>

        <div >
          <Row>
            <Col span={24}>
              <Row style={{ marginTop: 16 }}>
                <Col span={18} style={{ marginTop: 8, paddingRight: 12 }}>

                  {/* 专业要求及专业匹配 */}
                  {/*登录后专业匹配情况 <Badge.Ribbon text={<><LikeFilled /> 专业匹配</>} color="red"> */}
                  {/* <Badge.Ribbon 
                  text={<>登录查看专业匹配情况</>}
                   color='cyan'>
               
                  </Badge.Ribbon> */}
                  <Card title='专业需求' bordered={false} style={{ borderRadius: 12 }} >
                    <div>
                      <Space size={[8, 16]} wrap align='center'>
                        {recruitmentInfo && recruitmentInfo?.professionList && recruitmentInfo?.professionList.length >= 1 && recruitmentInfo?.professionList.map((item, index) => (
                          <span key={index}><TagsFilled style={{ color: '#ccc' }} />  {item.content}</span>
                        ))}
                        {recruitmentInfo && recruitmentInfo?.professionList && recruitmentInfo?.professionList.length == 0 && <Tag color="green">不限专业</Tag>}
                      </Space>
                    </div>
                  </Card>
                  {recruitmentInfo && recruitmentInfo?.politicalStatusList && recruitmentInfo?.politicalStatusList.length >= 1 && <div>
                    <Divider orientation="left" orientationMargin="0" style={{ marginTop: 18 }}>政治面貌</Divider>
                    <div>
                      <Space size={[8, 16]} wrap>
                        {recruitmentInfo && recruitmentInfo?.politicalStatusList && recruitmentInfo?.politicalStatusList.length >= 1 && recruitmentInfo?.politicalStatusList.map((item, index) => (

                          // <Button key={index}>{item.content}</Button>
                          <Tag key={index} color="gold">{item.content}</Tag>
                        ))}
                      </Space>
                    </div>
                  </div>}
                  {recruitmentInfo && recruitmentInfo?.industryList && recruitmentInfo?.industryList.length >= 1 && <div>
                    <Divider orientation="left" orientationMargin="0" style={{ marginTop: 18 }}>行业要求</Divider>
                    <div>
                      <Space size={[8, 16]} wrap>
                        {recruitmentInfo && recruitmentInfo?.industryList && recruitmentInfo?.industryList.length >= 1 && recruitmentInfo?.industryList.map((item, index) => (

                          // <Button key={index}>{item.content}</Button>
                          <Tag key={index} color="gold">{item.content}</Tag>
                        ))}
                      </Space>
                    </div>
                  </div>}

                  {/* 职位描述信息 */}
                  <Card title='职位描述' style={{ marginTop: 25, borderRadius: 12 }} bordered={false} >
                    {/* <div style={{ minHeight: '120px',  overflow: 'auto' }}><pre>{recruitmentInfo?.jobResponsibilityDescribe}</pre></div> */}
                    <div dangerouslySetInnerHTML={{ __html: "" + recruitmentInfo?.jobResponsibilityDescribe }}></div>
                    <Divider orientation="left" orientationMargin="0" style={{ marginTop: 18 }}></Divider>
                    <Card bordered={false}
                      bodyStyle={{ paddingLeft: 0 }}
                      size='small'
                    >
                      <Meta
                        avatar={<Avatar style={{ backgroundColor: '#87d068' }} size='large' icon={<UserOutlined />} src={showUrl(recruitmentInfo?.userInfo?.avatarPath)} />}
                        title={recruitmentInfo?.userInfo?.name}
                        description={companyInfoDetail?.fullName}
                      />
                    </Card>

                  </Card>

                  {/* 安全提示 */}
                  <Card
                    title='安全提示'
                    style={{ marginTop: 25, background: 'url(https://img.bosszhipin.com/static/file/2022/e80yqyvz0u1661829813750.png) 0 0/100% auto no-repeat' }}
                    bordered={false}
                    headStyle={{ borderBottom: 0 }}
                    bodyStyle={{ paddingRight: 224, paddingTop: 0, paddingBottom: 80 }}
                  >
                    <div >用人单位不得对求职的毕业生做出任何损害求职者合法权益的违法违规行为，
                      包括但不限于扣押求职者证件、收取求职者财物、向求职者集资、让求职者入股、诱导求职者异地入职、异地参加培训、违法违规使用求职者简历等，
                      您一旦发现此类行为，请立即举报</div>
                    <div style={{ marginTop: 16, fontSize: 12 }}>
                      <Popover content={alertContent} placement='rightTop'>
                        <Button type='link' size='small' icon={<SoundOutlined />}><span style={{ fontSize: 12 }}>大学生就业更多安全防范常识<CaretRightOutlined /></span> </Button>
                      </Popover>
                    </div>

                  </Card>

                  {/* 单位信息和工商信息 */}
                  <Card title='单位信息' bodyStyle={{ padding: '1px 0 0 0' }} style={{ borderRadius: 12 }}>
                    <Space direction='vertical' size={0}>
                      <Card title='单位介绍' bordered={false} headStyle={{ background: '#fff', borderBottom: 0 }} bodyStyle={{ padding: '0 24px', minHeight: '120px', maxHeight: '300px', overflow: 'auto' }}>
                        {/* <div>{companyInfoDetail?.describle}</div> */}
                        <div dangerouslySetInnerHTML={{ __html: "" + companyInfoDetail?.describle }}></div>
                        {/* <div><pre>{companyInfoDetail?.describle}</pre></div> */}
                      </Card>
                      <Card title='工商信息' bordered={false} headStyle={{ background: '#fff', borderBottom: 0 }} bodyStyle={{ paddingTop: 0 }}>
                        <div >
                          {/* <Descriptions layout="vertical" bordered size='small'>
                            <Descriptions.Item label="企业名称">北京慧知视界科技有限公司</Descriptions.Item>
                            <Descriptions.Item label="法定代表人">Prepaid</Descriptions.Item>
                            <Descriptions.Item label="注册资本">800万元人民币</Descriptions.Item>
                            <Descriptions.Item label="成立日期" >
                              2014-06-24
                            </Descriptions.Item>

                            <Descriptions.Item label="注册地址 ">北京市通州区于家务乡聚富北路6号2号1层007</Descriptions.Item>
                            <Descriptions.Item label="登记状态">存续（在营、开业、在册）</Descriptions.Item>
                            <Descriptions.Item label="统一社会信用代码" span={3} >
                              91110114306406812E
                            </Descriptions.Item>
                            <Descriptions.Item label="经营范围" span={3}>
                              技术开发、技术推广、技术咨询、技术转让、技术服务；代理进出口；经济信息咨询；销售机械设备。（市场主体依法自主选择经营项目，开展经营活动；依法须经批准的项目，经相关部门批准后依批准的内容开展经营活动；不得从事国家和本区产业政策禁止和限制类项目的经营活动。）
                            </Descriptions.Item>
                          </Descriptions> */}
                          <Descriptions layout="vertical" bordered size='small'>
                            <Descriptions.Item label="企业名称">{qichachaCompany?.qichachaCompany?.name}</Descriptions.Item>
                            <Descriptions.Item label="法定代表人">{qichachaCompany?.qichachaCompany?.operName}</Descriptions.Item>
                            <Descriptions.Item label="注册资本">{qichachaCompany?.qichachaCompany?.registCapi}</Descriptions.Item>
                            <Descriptions.Item label="成立日期" >
                              {qichachaCompany?.qichachaCompany?.startDate?.substring(0, 11)}
                            </Descriptions.Item>
                            <Descriptions.Item label="注册地址 ">{qichachaCompany?.qichachaCompany?.address}</Descriptions.Item>
                            <Descriptions.Item label="登记状态">{qichachaCompany?.qichachaCompany?.status}</Descriptions.Item>
                            <Descriptions.Item label="统一社会信用代码" span={3} >
                              {qichachaCompany?.qichachaCompany?.creditCode}
                            </Descriptions.Item>
                            <Descriptions.Item label="经营范围" span={3}>
                              {qichachaCompany?.qichachaCompany?.scope}
                            </Descriptions.Item>
                          </Descriptions>
                        </div>
                      </Card>
                      <Card title='所在地' bordered={false} headStyle={{ background: '#fff', borderBottom: 0 }} bodyStyle={{ paddingTop: 0 }}>
                        <div >
                          {companyInfoDetail?.location?.showText}
                          {/* <div style={{width:'200px',height:'200px',border:'#ccc solid 1px',}} id="dituContent"></div> */}
                          {companyInfoDetail?.lat != undefined && companyInfoDetail?.lat != '' && companyInfoDetail?.lon != undefined && companyInfoDetail?.lon != '' && <div style={{ width: '100%', height: '200px', border: '#ccc solid 1px', }} id="dituContent">
                            {companyInfoDetail?.lat != undefined && companyInfoDetail?.lat != '' && companyInfoDetail?.lon != undefined && companyInfoDetail?.lon != '' && <MapComponent lat={companyInfoDetail?.lat} lng={companyInfoDetail?.lon}></MapComponent>}
                          </div>}

                        </div>
                      </Card>
                    </Space>
                  </Card>
                </Col>

                {/* 右侧单位通用信息 */}
                <Col span={6} style={{ marginTop: 8, paddingLeft: 12 }}>
                  <Card title='单位基本信息' style={{ borderRadius: 12 }} >
                    <Meta
                      avatar={<Avatar shape='square' size={48} src={showUrl(companyInfoDetail?.logo)} />}
                      title={<a style={{ color: '#333', fontSize: 16 }} onClick={() => {
                        window.open('/company/' + companyInfoDetail?.id + '/' + collegeId + '/1')
                      }}>{companyInfoDetail?.fullName}</a>}
                      description={<a onClick={() => {
                        window.open('/company/' + companyInfoDetail?.id + '/' + collegeId + '/2')
                      }}>查看全部职位<CaretRightOutlined /></a>}
                      style={{ paddingBottom: 16 }}
                    />
                    <Space direction='vertical'>
                      <div><HomeOutlined style={{ color: '#999999' }} /> {companyInfoDetail && companyInfoDetail?.location && <span>{companyInfoDetail?.location?.showText}</span>}</div>
                      <div><UserOutlined style={{ color: '#999999' }} /> {companyInfoDetail && companyInfoDetail?.companySize && <span>{companyInfoDetail?.companySize?.content}</span>}</div>
                      <div><AppstoreAddOutlined style={{ color: '#999999' }} /> {companyInfoDetail && companyInfoDetail?.companyType && <span>{companyInfoDetail?.companyType?.content}</span>}</div>
                      <div><GlobalOutlined style={{ color: '#999999' }} /> {companyInfoDetail && companyInfoDetail?.companyIndustryList && companyInfoDetail?.companyIndustryList.length >= 1 && companyInfoDetail?.companyIndustryList.map((item, index) => (
                        <span key={index}>{item.content}</span>
                      ))}</div>
                    </Space>
                  </Card>

                  {/* 工作时间及福利 */}
                  <div >
                    <Card title='工作时间及福利' style={{ borderRadius: 12, marginTop: 24 }}>
                      <div>
                        <Space direction='vertical' >
                          <span style={{ fontSize: 13 }} ><ClockCircleFilled style={{ color: '#cccccc', fontSize: 14, marginRight: 10 }} />{companyInfoDetail?.workingHoursStart}-{companyInfoDetail?.workingHoursEnd}</span>
                          <span style={{ fontSize: 13 }}><RestFilled style={{ color: '#cccccc', fontSize: 14, marginRight: 10 }} />{companyInfoDetail?.restTime?.content}</span>
                          <span style={{ fontSize: 13 }} ><HourglassFilled style={{ color: '#cccccc', fontSize: 14, marginRight: 10 }} />{companyInfoDetail?.overtimeCondition?.content}</span>

                        </Space>
                        <Space align="center" wrap style={{ marginTop: 16 }} >
                          {companyInfoDetail && companyInfoDetail?.welfarelList && companyInfoDetail?.welfarelList.length >= 1 && companyInfoDetail?.welfarelList.map((item, index) => (
                            // eslint-disable-next-line react/no-array-index-key
                            // <Button key={index}>{item.content}</Button>
                            <span style={{ background: '#f8f8f8', padding: '4px 15px', textAlign: 'center', borderRadius: 4, margin: '12px 4px 0 4px', maxWidth: '100%', width: 105, float: 'left', lineHeight: '20px' }} key={index}>{item.content}</span>
                          ))}
                        </Space>
                      </div>
                    </Card>
                    {/* <Card title='单位福利' style={{ marginTop: 24, borderRadius: 12 }}>
                      <div>
                        <Space size={[8, 16]} wrap>
                          {companyInfoDetail && companyInfoDetail?.welfarelList && companyInfoDetail?.welfarelList.length >= 1 && companyInfoDetail?.welfarelList.map((item, index) => (
                            <Tag key={index}>{item.content}</Tag>
                          ))}
                        </Space>
                      </div>
                    </Card> */}
                  </div>
                </Col>
              </Row>
            </Col>
          </Row>
        </div>
        {/* <Breadcrumb style={{ margin: '16px 0' }}>
          <Breadcrumb.Item> <HomeOutlined /> 长春工业大学就业信息网</Breadcrumb.Item>
          <Breadcrumb.Item>在线招聘</Breadcrumb.Item>
          <Breadcrumb.Item>产品经理</Breadcrumb.Item>
        </Breadcrumb> */}
      </Content>

      <Footer style={{ background: '#0000', textAlign: 'center' }}>慧就业提供技术支持</Footer>
    </Layout>
  );
};

export default JobDetailView;

